import React from "react";

// Rotating badge around the profile photo. Inline SVG text so the wording
// can change without redrawing artwork.
export default function CircularText({ text = "MUNAF ✦ PRODUCT ENGINEER ✦" }) {
	return (
		<svg
			className="circular-text"
			width="160"
			height="160"
			viewBox="0 0 160 160"
			aria-hidden="true"
			focusable="false"
		>
			<defs>
				<path
					id="circular-text-path"
					d="M80,80 m-66,0 a66,66 0 1,1 132,0 a66,66 0 1,1 -132,0"
				/>
			</defs>
			<text
				fontFamily="Prompt, sans-serif"
				fontSize="13"
				fontWeight="500"
				letterSpacing="2.6"
				fill="#000"
			>
				<textPath href="#circular-text-path" textLength="408">
					{text.split("✦").map((part, i, parts) => (
						<React.Fragment key={i}>
							{part}
							{i < parts.length - 1 && <tspan fill="#d00000">✦</tspan>}
						</React.Fragment>
					))}
				</textPath>
			</text>
		</svg>
	);
}
